import { Box, Button, Card, Container, InputBase, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Paper, Typography, Select, MenuItem, Dialog, DialogTitle, DialogContent, TextField, DialogActions, Popover, Checkbox, InputLabel, FormControl, TableHead } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Iconify from 'src/components/iconify';
import { getData, postData, putData, uploadFile } from 'src/webService/webService';
import PaginationComponent from 'src/components/pagination';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

function SalesDashboardPage() {

    const [open, setOpen] = useState(null)
    const [reqForm, setReqForm] = useState(false);
    const sessionToken = sessionStorage.getItem("Token");
    const [leadsData, setLeadsData] = useState([]);
    const [users, setUsers] = useState([]);
    const [selectedServiceType, setSelectedServiceType] = useState("");
    const [getLeadID, setGetLeadID] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [selectedServices, setSelectedServices] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState({});
    const [fileUpload, setFileUpload] = useState({});
    const [selectedLeadId, setSelectedLeadId] = useState('');
    const [callHistoryModalOpen, setCallHistoryModalOpen] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null);

    const [callHistoryDialogOpen, setCallHistoryDialogOpen] = useState(false);
    const [currentLeadId, setCurrentLeadId] = useState("");
    const [modalData, setModalData] = useState({
        show: false,
        lead: '',
        callId: '',
        defaultDate: '',
    });
    const [date, setDate] = useState(modalData?.defaultDate || "")

    const [callHistoryForm, setCallHistoryForm] = useState({
        status: "",
        callTime: new Date().toTimeString().slice(0, 5),
        callDate: new Date().toISOString().split('T')[0],
        appoinmentDate: "",
        summary: "",
        reason: "",
        contactDate: '',
        totalNoOfCalls: "",
        quotationFileObject: null,
    });

    const role = sessionStorage.getItem('role');
    const roleType = sessionStorage.getItem('roleType');

    const serviceOptions = [
        // "Sales",
        "Video Editing",
        "WebSite Designing",
        "SEO",
        "Social Media",
        "Graphic Designing",
        "Content Creation",
        "Camera Man"
    ];

    const [formData, setFormData] = useState({
        generalStatus: "Converted",
        serviceName: [],
        startDate: "",
        duration: "",
        callHistory: "",
        requirements: "",
        assignedUser: "",
        assignedTo: [],
        serviceStatus: "",
        progress: ""
    });

    const handleClickOpen = (leadId) => {
        const lead = leadsData.find(lead => lead._id === leadId);
        setSelectedLead(lead);
        setCallHistoryModalOpen(true);
    };

    const handleOpenMenu = (event, rowIndex, leadId) => {
        const leadData = leadsData[rowIndex];
        setFormData({
            ...leadData,
            assignedTo: Array.isArray(leadData.assignedTo)
                ? leadData.assignedTo
                : leadData.assignedTo ? [leadData.assignedTo] : []
        });
        setGetLeadID(leadId);
        setSelectedLeadId(leadId);
        setOpen(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setOpen(null);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleFileChange = (event, leadId) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFiles(prev => ({ ...prev, [leadId]: file }));
            handleFileUpload(file, leadId);
        }
    };

    const handleFileUpload = async (fileupload, leadId) => {
        console.log("Fileupload:", fileupload);
        console.log("Is File:", fileupload instanceof File);

        const formDataToSend = new FormData();
        formDataToSend.append("file", fileupload);

        try {
            const response = await uploadFile(`files/upload/${getLeadID}`, formDataToSend);
            if (response?.status === 200) {
                toast.success("File uploaded successfully!");
                setFileUpload(response?.data);
                setFormData(prevState => ({
                    ...prevState,
                    fileupload: response?.data,
                }));
            } else {
                toast.error("File upload failed!", response?.message);
            }
        } catch (error) {
            console.error("File upload error:", error);
            toast.error(`Error uploading file. ${error ? error : ''}`);
        }
    };

    const getAllLeads = async () => {
        const parmas = {
            page: currentPage,
            limit: limit
        }

        try {
            console.log("Fetching users...");
            console.log("Token being sent:", sessionToken);

            const response = await getData("leads/leads", parmas, sessionToken);
            console.log("Response:", response)

            const responseData = response?.data?.results?.[0]?.paginatedResults || [];

            checkUpcomingAppointments(responseData);

            // const today = new Date().toISOString().split('T')[0]; // 'YYYY-MM-DD'
            const todayISO = new Date().toISOString().split('T')[0]; // 'YYYY-MM-DD'
            const [year, month, day] = todayISO.split('-');
            const today = `${day}-${month}-${year}`;

            // Store the leads that need notification
            const leadsToNotify = responseData.filter(element => {
                const contactDate = element?.callHistory?.contactDate?.split('T')[0]?.split('-').reverse().join('-');
                return contactDate === today;
            });

            // Show notification for each lead and deactivate after confirmation
            for (const element of leadsToNotify) {
                const leadName = element?.name || "Unknown";
                const leadContact = element?.phone || "N/A";
                const leadCompany = element?.company || "N/A";

                // Wait for user to click Ok
                await Swal.fire({
                    title: 'Contact Needed',
                    text: `${leadName} (Contact: ${leadContact}) (Company: ${leadCompany}) enquired about a requirement a month ago.`,
                    icon: 'info',
                    confirmButtonText: 'Ok',
                });

                try {
                    console.log('Attempting to deactivate notification for:', element?.callHistory?._id);
                    const payload = {
                        CallHistoryId: element?.callHistory?._id
                    };
                    const deactivateResponse = await postData('callhistory/deactivate', payload, sessionToken);
                    console.log('Deactivation successful:', deactivateResponse);
                    console.log(`Notification deactivated for lead ${element._id}`);
                } catch (error) {
                    console.error('Deactivation failed:', error.response?.data || error);
                    await Swal.fire('Error', 'Failed to mark notification as read', 'error');
                }
            }

            const LeadId = responseData.length > 0 ? responseData[0]._id : null;

            setGetLeadID(LeadId);

            console.log("Leads Id:", LeadId);

            console.log("ResponseData", responseData)

            setLeadsData(responseData);
            setTotalPages(response.data.results[0].totalPages);
            setTotalCount(response.data.results[0].totalCount);

        } catch (error) {
            console.error("Error fetching users:", error);
        }
    }

    const getAllLeadsForEmployee = async () => {
        const userId = sessionStorage.getItem("userId");
        const params = {
            page: currentPage,
            limit: limit
        }
        try {

            const response = await getData(`leads/leads/${userId}`, params, sessionToken);
            console.log("Employee Leads Response:", response);

            const responseData = response?.data[0]?.paginatedResults || [];
            checkUpcomingAppointments(responseData);

            const LeadId = responseData.length > 0 ? responseData[0]._id : null;

            setGetLeadID(LeadId);
            console.log("Leads Id:", LeadId);
            console.log("Employee Leads Data:", responseData);

            setLeadsData(responseData);
            setTotalPages(response?.data[0]?.totalPages);
            setTotalCount(response?.data[0]?.totalCount?.totalItems);

        } catch (error) {
            console.error("Error fetching employee leads:", error);
            toast.error(`Failed to load your assigned leads ${error ? error : ''}`);
        }
    }

    const getAllUsers = async (selectedServices) => {
        try {
            const params = { page: 1, limit: 1000 }
            const response = await getData("users/users", params);
            console.log("Response:", response);

            const filteredUsers = response.data.results.filter(
                user =>
                    user.role === "Service" &&
                    user.roleType === "Team Leader" &&
                    selectedServices.includes(user.serviceTeamType)
            );

            setUsers(filteredUsers);
        } catch (error) {
            console.error("Error fetching users:", error);
            toast.error(`Failed to load users ${error ? error : ''}`);
        }
    };

    const putService = async () => {
        debugger;
        try {
            const id = getLeadID;
            const sessionToken = sessionStorage.getItem("Token");

            if (!sessionToken) {
                toast.error("Authentication Error! Please login again.");
                return;
            }

            // Prepare PUT payload
            const putPayload = {
                ...formData,
                quotationFileObject: fileUpload,
                serviceName: Array.isArray(formData.serviceName)
                    ? formData.serviceName
                    : [formData.serviceName],
                assignedTo: Array.isArray(formData.assignedTo)
                    ? formData.assignedTo
                    : [formData.assignedTo || ""]
            };

            // Perform PUT operation
            const putResponse = await putData(`leads/lead/${id}/status`, putPayload, sessionToken);

            if (!putResponse?.data?._id) {
                throw new Error("PUT operation failed.");
            }

            toast.success("Lead Converted successfully!");
            setLeadsData(prev =>
                prev.map(lead => lead._id === id ? { ...lead, ...putPayload } : lead)
            );

            setReqForm(false);
            handleCloseMenu();
            await getAllLeads();

        } catch (error) {
            console.error("Service update error:", error);
            toast.error(`Operation failed: ${error}`);
        }
    };

    useEffect(() => {
        if (roleType === "Team Leader" || role === "Admin") {
            getAllLeads(currentPage, limit);
        } else if (roleType === "Employee") {
            getAllLeadsForEmployee(currentPage, limit);
        }
    }, [currentPage, limit, roleType]);

    useEffect(() => {
        if (selectedServiceType) {
            getAllUsers(selectedServiceType);
        }
    }, [selectedServiceType]);

    useEffect(() => {
        if (users.length > 0) {
            setFormData((prevData) => ({
                ...prevData,
                assignedTo: users[0]?.id || "",
            }));
        }
    }, [users]);

    const checkUpcomingAppointments = async (leads) => {
        if (!leads || !Array.isArray(leads)) {
            console.error("Invalid leads data:", leads);
            return;
        }

        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        const tomorrowFormatted = tomorrow.toISOString().split('T')[0];

        for (const lead of leads) {
            try {
                if (!lead?.callHistory?.length) continue;

                const lastCall = lead.callHistory[lead.callHistory.length - 1];
                if (!lastCall?.appoinmentDate) continue;

                const appointmentDate = new Date(lastCall.appoinmentDate).toISOString().split('T')[0];
                if (appointmentDate !== tomorrowFormatted) continue;

                // Show alert one day before appointment
                const result = await Swal.fire({
                    title: 'Appointment Reminder',
                    html: `You have an appointment tomorrow with <b>${lead.name || 'Unknown'}</b> <br>
                    Contact: ${lead.phone || 'N/A'}<br>
                    Email: ${lead.email || 'N/A'}<br>
                    Company: ${lead.company || 'N/A'}<br>`,
                    icon: 'info',
                    confirmButtonText: 'Ok'
                });

                if (result.isConfirmed) {
                    debugger
                    setModalData({
                        show: true,
                        lead,
                        callId: lastCall._id,
                        defaultDate: tomorrowFormatted,
                    });
                }
            } catch (error) {
                console.error("Error processing lead:", lead?._id, error);
            }
        }
    };

    const handleSubmit = async () => {
        try {
            const response = await putData(
                `callhistory/${modalData.callId}`,
                {
                    appoinmentConfirmation: date
                },
                sessionToken
            );

            if (response?.status === 200) {
                toast.success('Appointment confirmed successfully');
            } else {
                toast.error('Failed to confirm appointment', response?.message);
            }
        } catch (error) {
            toast.error(`Error confirming appointment ${error ? error : ''}`);
            console.error(error);
        }

        setModalData({ ...modalData, show: false });
    };

    const handleLimitChange = (event) => {
        if (roleType === "Employee") {
            setCurrentPage(1);
            if (currentPage === 1) {
                setLimit(event.target.value)
                getAllLeadsForEmployee(1, event.target.value)
            }
            else {
                setCurrentPage(1);
                setLimit(event.target.value);
            }
        } else {
            setCurrentPage(1);
            if (currentPage === 1) {
                setLimit(event.target.value)
                getAllLeads(1, event.target.value)
            }
            else {
                setCurrentPage(1);
                setLimit(event.target.value);
            }
        }
    };

    const handlePrevPage = () => {
        if (roleType === "Employee") {
            if (currentPage > 1) {
                setCurrentPage((prev) => prev - 1);
                getAllLeadsForEmployee(currentPage - 1, limit);
            }
        } else {
            if (currentPage > 1) {
                setCurrentPage((prev) => prev - 1);
                getAllLeads(currentPage - 1, limit);
            }
        }
    };

    const handleNextPage = () => {
        if (roleType === "Employee") {
            if (currentPage < totalPages) {
                setCurrentPage((prev) => prev + 1);
                getAllLeadsForEmployee(currentPage + 1, limit);
            }
        } else {
            if (currentPage < totalPages) {
                setCurrentPage((prev) => prev + 1);
                getAllLeads(currentPage + 1, limit);
            }
        }
    };

    const calculateIndex = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    const renderBasicInfoSteps = () => {
        return (
            <>
                <TextField margin="dense" select label="General Status" name="generalStatus" value={formData.generalStatus} onChange={handleInputChange} defaultValue="Converted" fullWidth >
                    <MenuItem value="Interested">Interested</MenuItem>
                    <MenuItem value="Not Interested">Not Interested</MenuItem>
                    <MenuItem value="Follow-up Needed">Follow-up Needed</MenuItem>
                    <MenuItem value="Converted">Converted</MenuItem>
                </TextField>
                {
                    formData.generalStatus === "Converted" && (
                        <>
                            <FormControl fullWidth margin="dense">
                                <InputLabel>Service Type</InputLabel>
                                <Select
                                    multiple
                                    name="serviceName"
                                    value={selectedServices}
                                    onChange={(e) => {
                                        const selectedValues = e.target.value;
                                        setSelectedServices(selectedValues);
                                        setFormData(prev => ({
                                            ...prev,
                                            serviceName: selectedValues
                                        }));
                                        getAllUsers(selectedValues);
                                    }}
                                    renderValue={(selected) => selected.join(", ")}
                                >
                                    {serviceOptions.map((service) => (
                                        <MenuItem key={service} value={service}>
                                            <Checkbox checked={selectedServices.includes(service)} />
                                            <Typography>{service}</Typography>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <FormControl fullWidth margin="dense">
                                <InputLabel>Assigned Users</InputLabel>
                                <Select
                                    multiple
                                    name="assignedTo"
                                    value={Array.isArray(formData.assignedTo) ? formData.assignedTo : []}
                                    onChange={(e) => {
                                        const selectedValues = e.target.value;
                                        setFormData(prev => ({
                                            ...prev,
                                            assignedTo: Array.isArray(selectedValues) ? selectedValues : [selectedValues]
                                        }));
                                    }}
                                    renderValue={(selected) => {
                                        if (!selected || selected.length === 0) return <em>No users selected</em>;
                                        return selected.map(userId => {
                                            const user = users.find(u => u._id === userId);
                                            return user ? user.name : "";
                                        }).join(", ");
                                    }}
                                >
                                    {users.map((user) => (
                                        <MenuItem key={user._id} value={user._id}>
                                            <Checkbox checked={formData.assignedTo?.includes(user._id) || false} />
                                            <Typography>{`${user.name} (${user.role} - ${user.roleType})`}</Typography>
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            <TextField
                                margin='dense'
                                type='file'
                                hidden
                                label="Upload Quotation (PDF or DOCX)"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                onChange={handleFileChange}>
                            </TextField>
                        </>
                    )
                }
            </>
        )
    }

    useEffect(() => {
        if (leadsData) {
            checkUpcomingAppointments(leadsData);
        }
    }, [leadsData]);

    return (
        <>
            <Helmet>
                <title>Sales Dashboard</title>
            </Helmet>
            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Sales Dashboard
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "white",
                                borderRadius: "15px",
                                padding: "4px 12px",
                                boxShadow: 1,
                                marginRight: "20px"
                            }}
                        >
                            <Iconify icon="eva:search-fill" />
                            <InputBase
                                placeholder="Search"
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box>
                    </Box>
                </Stack>

                <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>

                    <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                        {
                            role === "Admin" || roleType === "Team Leader" ? (
                                <Table>
                                    <TableHead>
                                        <TableCell>S.No</TableCell>
                                        <TableCell>Lead Name</TableCell>
                                        <TableCell>Contact</TableCell>
                                        <TableCell>Created</TableCell>
                                        <TableCell>Call History</TableCell>
                                        <TableCell>Appointment</TableCell>
                                        {
                                            role !== "Admin" && (
                                                <TableCell>Add Call History</TableCell>
                                            )
                                        }
                                        <TableCell></TableCell>
                                    </TableHead>
                                    <TableBody>
                                        {leadsData.map((lead, index) => {
                                            return (
                                                <TableRow key={lead._id}>
                                                    <TableCell>{calculateIndex(index)}</TableCell>
                                                    <TableCell>
                                                        <Typography variant="caption">
                                                            {lead.name}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography variant='caption'>{lead.phone}</Typography>
                                                    </TableCell>
                                                    <TableCell>{new Date(lead.createdAt).toLocaleDateString()}</TableCell>
                                                    <TableCell>
                                                        <Typography variant='caption' onClick={() => {
                                                            debugger
                                                            handleClickOpen(lead._id)
                                                        }}>
                                                            {lead?.callHistory?.length > 0
                                                                ? lead.callHistory[lead.callHistory.length - 1].summary
                                                                : "-"}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell style={{ maxWidth: 125 }}>
                                                        {lead?.callHistory?.length > 0 && lead.callHistory[lead.callHistory.length - 1].appoinmentDate
                                                            ? new Date(lead.callHistory[lead.callHistory.length - 1].appoinmentDate).toLocaleDateString('en-GB')
                                                            : "-"}
                                                    </TableCell>
                                                    {
                                                        role !== "Admin" && (
                                                            <TableCell>
                                                                <Button
                                                                    onClick={() => {
                                                                        setCurrentLeadId(lead._id);
                                                                        setCallHistoryDialogOpen(true);
                                                                    }}
                                                                >
                                                                    Add
                                                                </Button>
                                                            </TableCell>
                                                        )
                                                    }
                                                    <TableCell sx={{ cursor: "pointer" }}>
                                                        <Iconify
                                                            icon={"material-symbols-light:more-vert"}
                                                            sx={{ margin: "auto" }}
                                                            onClick={(event) => handleOpenMenu(event, index, lead._id)}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            ) : (
                                <Table>
                                    <TableHead>
                                        <TableCell>S.No</TableCell>
                                        <TableCell>Lead Name</TableCell>
                                        <TableCell>Contact</TableCell>
                                        <TableCell>Company</TableCell>
                                        <TableCell>Created</TableCell>
                                        <TableCell>Call History</TableCell>
                                        <TableCell>Appointment</TableCell>
                                        <TableCell>Add History</TableCell>
                                        <TableCell></TableCell>
                                    </TableHead>
                                    <TableBody>
                                        {leadsData.map((lead, index) => {
                                            return (
                                                <TableRow key={lead._id}>
                                                    <TableCell>{calculateIndex(index)}</TableCell>
                                                    <TableCell>
                                                        <Typography variant="caption">
                                                            {lead.name}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography variant='caption'>{lead.phone}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography variant='caption'>{lead.company}</Typography>
                                                    </TableCell>
                                                    <TableCell>{new Date(lead.createdAt).toLocaleDateString()}</TableCell>
                                                    <TableCell>
                                                        <Typography variant='caption' onClick={() => {
                                                            debugger
                                                            handleClickOpen(lead._id)
                                                        }}>
                                                            {lead?.callHistory?.length > 0
                                                                ? lead.callHistory[lead.callHistory.length - 1].summary
                                                                : "-"}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell style={{ maxWidth: 125 }}>
                                                        {lead?.callHistory?.length > 0 && lead.callHistory[lead.callHistory.length - 1].appoinmentDate
                                                            ? new Date(lead.callHistory[lead.callHistory.length - 1].appoinmentDate).toLocaleDateString('en-GB')
                                                            : "-"}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Button
                                                            onClick={() => {
                                                                setCurrentLeadId(lead._id);
                                                                setCallHistoryDialogOpen(true);
                                                            }}
                                                        >
                                                            Add
                                                        </Button>
                                                    </TableCell>
                                                    {/* <TableCell>
                                                            <Typography variant='caption'>{lead?.serviceHistory[0]?.serviceName.map((item, index) => (item))}</Typography>
                                                        </TableCell> */}
                                                    <TableCell sx={{ cursor: "pointer" }}>
                                                        <Iconify
                                                            icon={"material-symbols-light:more-vert"}
                                                            sx={{ margin: "auto" }}
                                                            onClick={(event) => handleOpenMenu(event, index, lead._id)}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            )
                        }
                    </TableContainer>

                    <PaginationComponent
                        name={"Leads"}
                        totalcount={totalCount}
                        limit={limit}
                        handleLimitChange={handleLimitChange}
                        handlePrevPage={handlePrevPage}
                        handleNextPage={handleNextPage}
                        currentPage={currentPage}
                        totalPages={totalPages}
                    />
                </Card>

                {/* Edit Menu  */}
                <Popover
                    open={Boolean(open)}
                    anchorEl={open}
                    onClose={handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            p: 1,
                            width: 140,
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75,
                            },
                        },
                    }}
                >
                    <MenuItem onClick={() => { setReqForm(true); handleCloseMenu() }}>
                        <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
                        Edit
                    </MenuItem>
                    <MenuItem sx={{ color: 'error.main' }}>
                        <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                        Delete
                    </MenuItem>
                </Popover>

                {/* Add Service  */}
                <Dialog
                    open={reqForm}
                    onClose={() => { setReqForm(false) }}
                    sx={{ maxWidth: 700, width: "100%", margin: "0 auto", alignItems: "center" }}
                >
                    <DialogTitle>
                        Convert Lead
                    </DialogTitle>
                    <DialogContent>
                        {renderBasicInfoSteps()}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setReqForm(false)}>
                            Cancel
                        </Button>
                        <Button onClick={putService} color="primary">
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={callHistoryDialogOpen} onClose={() => setCallHistoryDialogOpen(false)} sx={{ maxWidth: 700, width: "100%", margin: "0 auto", alignItems: "center" }}>
                    <DialogTitle>Add Call History</DialogTitle>
                    <DialogContent>
                        <Stack spacing={2} sx={{ mt: 1 }}>
                            {/* Call Date */}
                            <TextField
                                label="Call Date"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={callHistoryForm.callDate}
                                onChange={(e) => setCallHistoryForm({ ...callHistoryForm, callDate: e.target.value })}
                                fullWidth
                            />

                            {/* Call Time */}
                            <TextField
                                label="Call Time"
                                type="time"
                                InputLabelProps={{ shrink: true }}
                                value={callHistoryForm.callTime}
                                onChange={(e) => setCallHistoryForm({ ...callHistoryForm, callTime: e.target.value })}
                                fullWidth
                            />

                            {/* Summary */}
                            <TextField
                                label="Summary"
                                multiline
                                rows={3}
                                value={callHistoryForm.summary}
                                onChange={(e) => setCallHistoryForm({ ...callHistoryForm, summary: e.target.value })}
                                fullWidth
                            />

                            <FormControl fullWidth>
                                <InputLabel>Media</InputLabel>
                                <Select
                                    value={callHistoryForm.media}
                                    label="Media"
                                    onChange={(e) => setCallHistoryForm({ ...callHistoryForm, media: e.target.value })}
                                >
                                    <MenuItem value="Phone Call">Phone Call</MenuItem>
                                    <MenuItem value="Whatsapp">Whatsapp</MenuItem>
                                </Select>
                            </FormControl>

                            {/* Status  */}
                            <FormControl fullWidth>
                                <InputLabel>Status</InputLabel>
                                <Select
                                    value={callHistoryForm.status}
                                    label="Status"
                                    onChange={(e) => setCallHistoryForm({ ...callHistoryForm, status: e.target.value })}
                                >
                                    <MenuItem value="Interested">Interested</MenuItem>
                                    <MenuItem value="Not Interested">Not Interested</MenuItem>
                                    <MenuItem value="Under Follow-Up">Under Follow-Up</MenuItem>
                                </Select>
                            </FormControl>

                            {callHistoryForm.status === "Interested" && (
                                <>
                                    < TextField
                                        label="Appointment Date"
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        value={callHistoryForm.appoinmentDate}
                                        onChange={(e) => setCallHistoryForm({ ...callHistoryForm, appoinmentDate: e.target.value })}
                                        fullWidth
                                    />
                                    {/* < TextField
                                        label="Appointment Confirmation"
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        value={callHistoryForm.appoinmentConfirmation}
                                        onChange={(e) => setCallHistoryForm({ ...callHistoryForm, appoinmentConfirmation: e.target.value })}
                                        fullWidth
                                    /> */}
                                    <TextField
                                        margin='dense'
                                        type='file'
                                        hidden
                                        label="Upload Quotation (PDF or DOCX)"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        onChange={handleFileChange}>
                                    </TextField>
                                </>
                            )}
                            {callHistoryForm.status === "Not Interested" && (
                                <FormControl fullWidth>
                                    <InputLabel>Reason</InputLabel>
                                    <Select
                                        value={callHistoryForm.reason}
                                        onChange={(e) => {
                                            const selectedReason = e.target.value;
                                            setCallHistoryForm({
                                                ...callHistoryForm,
                                                reason: selectedReason,
                                                // contactDate: selectedReason === 'Contact in Future' ? getNextMonthDate() : '',
                                            });
                                        }}
                                    >
                                        <MenuItem value="Contact in Future">Contact in Future</MenuItem>
                                        <MenuItem value="False Enquiry">False Enquiry</MenuItem>
                                    </Select>
                                </FormControl>
                            )}
                            {callHistoryForm.reason === 'Contact in Future' && (
                                <TextField
                                    fullWidth
                                    label="Follow-up Date"
                                    type="date"
                                    value={callHistoryForm.contactDate}
                                    onChange={(e) =>
                                        setCallHistoryForm({ ...callHistoryForm, contactDate: e.target.value })
                                    }
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    sx={{ mt: 2 }}
                                />
                            )}
                            {callHistoryForm.status === "Under Follow-Up" && (
                                <>
                                    <TextField
                                        label="Follow-up Date"
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        value={callHistoryForm.followUpDate}
                                        onChange={(e) => setCallHistoryForm({ ...callHistoryForm, followUpDate: e.target.value })}
                                        fullWidth
                                    />
                                    <Typography variant="body2" color="text.secondary">
                                        This lead is postponed to the {callHistoryForm.followUpDate} for follow-up.
                                    </Typography>
                                </>
                            )}
                        </Stack>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setCallHistoryDialogOpen(false)}>Cancel</Button>
                        <Button
                            onClick={async () => {
                                debugger
                                try {
                                    // Prepare the payload
                                    const payload = {
                                        userId: sessionStorage.getItem("userId"),
                                        leadId: currentLeadId,
                                        quotationFileObject: fileUpload,
                                        status: callHistoryForm.status,
                                        callTime: callHistoryForm.callTime,
                                        callDate: callHistoryForm.callDate,
                                        appoinmentDate: callHistoryForm.appoinmentDate,
                                        followUpDate: callHistoryForm.followUpDate,
                                        appoinmentConfirmation: callHistoryForm.appoinmentConfirmation,
                                        summary: callHistoryForm.summary,
                                        media: callHistoryForm.media,
                                        reason: callHistoryForm.reason,
                                        contactDate: callHistoryForm.contactDate,
                                        totalNoOfCalls: callHistoryForm.totalNoOfCalls
                                    };

                                    // Make the API call
                                    const response = await postData('callhistory', payload, sessionToken);

                                    if (response?.data) {
                                        toast.success("Call history added successfully!");
                                        setCallHistoryDialogOpen(false);

                                        // Reset form
                                        setCallHistoryForm({
                                            status: "",
                                            callTime: new Date().toTimeString().slice(0, 5),
                                            callDate: new Date().toISOString().split('T')[0],
                                            appoinmentDate: "",
                                            summary: "",
                                            reason: "",
                                            media: "",
                                            totalNoOfCalls: "1",
                                            quotationFileObject: null,
                                        });

                                        // Refresh the leads data
                                        if (roleType === "Team Leader" || role === "Admin") {
                                            getAllLeads(currentPage, limit);
                                        } else {
                                            getAllLeadsForEmployee(currentPage, limit);
                                        }
                                    }
                                } catch (error) {
                                    toast.error(`Failed to add call history ${error ? error : ''}`);
                                    console.error("Error adding call history:", error);
                                }
                            }}
                            variant="contained"
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Appointment Confirmation Modal */}
                <Dialog
                    open={modalData?.show || false}
                    onClose={() => setModalData({ ...modalData, show: false })}
                >
                    <DialogTitle>Confirm Appointment Date</DialogTitle>
                    <DialogContent>
                        <TextField
                            sx={{ mt: 2 }}
                            label="Appointment Confirmation Date"
                            type="date"
                            value={date}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => setDate(e.target.value)}
                            fullWidth
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setModalData({ ...modalData, show: false })}>
                            Cancel
                        </Button>
                        <Button onClick={handleSubmit} color="primary">
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={callHistoryModalOpen}>
                    <DialogTitle>Call History for {selectedLead?.name}</DialogTitle>
                    <DialogContent>
                        {selectedLead?.callHistory?.length > 0 ? (
                            <Table>
                                <TableHead>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Media</TableCell>
                                    <TableCell>Summary</TableCell>
                                    {/* <TableCell>Appointment Date</TableCell> */}
                                </TableHead>
                                <TableBody>
                                    {selectedLead.callHistory.map((history) => (
                                        <TableRow key={history._id}>
                                            <TableCell>{new Date(history.callDate).toLocaleDateString()}</TableCell>
                                            <TableCell>{history.media}</TableCell>
                                            <TableCell>{history.summary}</TableCell>
                                            {/* <TableCell>
                                                    {history.appoinmentDate
                                                        ? new Date(history.appoinmentDate).toLocaleDateString('en-GB')
                                                        : "-"}
                                                </TableCell> */}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        ) : (
                            <Typography>No call history available</Typography>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setCallHistoryModalOpen(false)}>Close</Button>
                    </DialogActions>
                </Dialog>

            </Container >
        </>
    );
}

export default SalesDashboardPage;